module.exports = __webpack_public_path__ + "static/media/avatar.ba254f38.jpg";